'use client';

import BaseHeader from '../../../../../components/header/Header';
import MagicBar from '../commons/MagicBar';
import NavBar from '../commons/NavBar';
import FilterBar from './filter/FilterBar';

export default function Header() {
  return (
    <BaseHeader
      renderCenter={
        <div className="tw-hidden md:tw-block">
          {/* To hide the address bar */}
          <MagicBar />
        </div>
      }
      renderBottom={
        <>
          <div className="tw-block md:tw-hidden tw-pb-3 tw-space-y-3">
            <div className="tw-container tw-mx-auto tw-px-4">
              {/* To hide the address bar */}
              {<MagicBar />}
            </div>
            {<FilterBar />}
          </div>
          <div className="tw-hidden md:tw-block">
            <NavBar />
          </div>
        </>
      }
    />
  );
}
